<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="60%" :top="'8vh'">
        <div class="dialogClass">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane :label="$t('integration.escalation_rules')" name="ConfigRule">
                    <span slot="label">
                        <i class="el-icon-warning" :class="activeName === 'ConfigRule' ? 'active' : ''" v-show="activeName === 'ConfigRule' && $attrs.rowData.configStatus === 1"></i>
                        {{ $t('integration.escalation_rules') }}
                    </span>
                </el-tab-pane>
                <el-tab-pane :label="$t('device.config_log')" name="configLog"></el-tab-pane>
            </el-tabs>
            <keep-alive>
                <component :is="activeName" v-bind="$attrs" />
            </keep-alive>
        </div>
    </modal>
</template>

<script>
import ConfigRule from '../config/ConfigRule.vue';
import ConfigLog from '../config/ConfigLog.vue';
export default {
    props: ['title', 'isShowConfig'],
    components: {
        ConfigRule,
        ConfigLog
    },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShowConfig;
            },
            set: function(val) {
                this.$emit('update:isShowConfig', val); //可以优化成model  或者minx
            }
        }
    },
    data() {
        return {
            activeName: 'ConfigRule'
        };
    },
    methods: {
        handleClick() {}
    }
};
</script>

<style lang="scss" scoped>
.dialogClass {
    height: 700px;
}

.active {
    color: red;
    margin-right: 5px;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background-color: var(--primary-color);
    color: #fff;
}
</style>
